import { ImageViewerService } from './image-viewer.service';
import { Component, HostListener } from '@angular/core';

enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  ESCAPE = 27,
}

@Component({
  selector: 'image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
})
export class ImageViewerComponent {
  constructor(public imageViewerService: ImageViewerService) {}

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    switch (event.keyCode) {
      case KEY_CODE.RIGHT_ARROW: {
        this.next();
        break;
      }
      case KEY_CODE.LEFT_ARROW: {
        this.prev();
        break;
      }
      case KEY_CODE.ESCAPE: {
        this.close();
        break;
      }
    }
  }

  prev() {
    this.imageViewerService.showPrev();
  }

  next() {
    this.imageViewerService.showNext();
  }

  close() {
    this.imageViewerService.clear();
  }
}
